"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEpisodeNumberProperty = exports.episodeNumberPropertyDefinition = void 0;
exports.episodeNumberPropertyDefinition = {
    view: { label: 'Episode number' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'int',
    multiple: false,
    name: 'episode-number',
};
const isEpisodeNumberProperty = (prop) => {
    return prop.name === exports.episodeNumberPropertyDefinition.name;
};
exports.isEpisodeNumberProperty = isEpisodeNumberProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXBpc29kZS1udW1iZXIucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9lcGlzb2RlLW51bWJlci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxnQkFBZ0IsRUFBRTtJQUNqQyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtJQUNELElBQUksRUFBRSxLQUFLO0lBQ1gsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsZ0JBQWdCO0NBQ1MsQ0FBQTtBQUkxQixNQUFNLHVCQUF1QixHQUFHLENBQUMsSUFBa0IsRUFBaUMsRUFBRTtJQUMzRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssdUNBQStCLENBQUMsSUFBSSxDQUFBO0FBQzNELENBQUMsQ0FBQTtBQUZZLFFBQUEsdUJBQXVCLDJCQUVuQyJ9